import React, { useState, useEffect } from 'react';
import API_BASE_URL from './config';

function formatDate(dateStr) {
  if (!dateStr) return '';
  return dateStr.split('T')[0];
}

function Movements() {
  const [cars, setCars] = useState([]);
  const [selectedCar, setSelectedCar] = useState('');
  const [month, setMonth] = useState('');
  const [date, setDate] = useState('');
  const [debit, setDebit] = useState('');
  const [credit, setCredit] = useState('');
  const [movements, setMovements] = useState([]);
  const [search, setSearch] = useState('');
  const [message, setMessage] = useState('');
  const [details, setDetails] = useState('');
  const [category, setCategory] = useState('اخري');
  const [editId, setEditId] = useState(null);
  const [sortBy, setSortBy] = useState('seq'); // 'seq', 'date'
  const [sortOrder, setSortOrder] = useState('asc'); // 'asc', 'desc'

  useEffect(() => {
    fetch(`${API_BASE_URL}/cars`)
      .then(res => res.json())
      .then(data => setCars(data));
    fetchMovements();
  }, []);

  const fetchMovements = () => {
    fetch(`${API_BASE_URL}/movements`)
      .then(res => res.json())
      .then(data => setMovements(data));
  };

  // دالة الترتيب
  const handleSort = (field) => {
    const newOrder = sortBy === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortBy(field);
    setSortOrder(newOrder);
  };

  // تطبيق الترتيب على البيانات
  const sortedMovements = [...movements].sort((a, b) => {
    let aValue, bValue;
    
    if (sortBy === 'seq') {
      aValue = a.seq || 0;
      bValue = b.seq || 0;
    } else if (sortBy === 'date') {
      aValue = new Date(a.date);
      bValue = new Date(b.date);
    }
    
    if (sortOrder === 'asc') {
      return aValue > bValue ? 1 : -1;
    } else {
      return aValue < bValue ? 1 : -1;
    }
  });

  const handleAddMovement = async (e) => {
    e.preventDefault();
    setMessage('');
    if (!debit && !credit) {
      setMessage('يجب إدخال المسحوبات أو الشغل على الأقل');
      return;
    }
    if (editId) {
      // تعديل حركة
      const res = await fetch(`${API_BASE_URL}/movements/${editId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ car_id: selectedCar, month, date, debit: debit || undefined, credit: credit || undefined, details, category })
      });
      const data = await res.json();
      if (data.success) {
        setMessage('تم تعديل الحركة بنجاح');
        setEditId(null);
        fetchMovements();
        setMonth(''); setDate(''); setDebit(''); setCredit(''); setDetails(''); setCategory('اخري');
      } else {
        setMessage(data.message || 'حدث خطأ');
      }
      return;
    }
    // إضافة حركة جديدة
    const res = await fetch(`${API_BASE_URL}/movements`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ car_id: selectedCar, month, date, debit: debit || undefined, credit: credit || undefined, details, category })
    });
    const data = await res.json();
    if (data.success) {
      fetchMovements();
      setMonth(''); setDate(''); setDebit(''); setCredit(''); setDetails(''); setCategory('اخري');
      setMessage('تمت إضافة الحركة بنجاح');
    } else {
      setMessage(data.message || 'حدث خطأ');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('هل أنت متأكد من حذف الحركة؟')) return;
    const res = await fetch(`${API_BASE_URL}/movements/${id}`, { method: 'DELETE' });
    const data = await res.json();
    if (data.success) {
      setMessage('تم حذف الحركة بنجاح');
      // إعادة جلب الحركات لإعادة التسلسل
      fetchMovements();
    } else {
      setMessage(data.message || 'حدث خطأ');
    }
  };

  const handleEdit = (m) => {
    setEditId(m.id);
    setSelectedCar(m.car_id);
    setMonth(m.month);
    setDate(formatDate(m.date));
    setDebit(m.debit || '');
    setCredit(m.credit || '');
    setDetails(m.details || '');
    setCategory(m.category || 'اخري');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div dir="rtl" className="w-full max-w-none mx-auto px-2 py-6 lg:px-3" style={{ direction: 'rtl', textAlign: 'right' }}>
      <div className="mb-8 animate-slideInDown">
        <h2 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-2">
          جدول الحركات
        </h2>
        <p className="text-gray-600">إدارة وتسجيل حركات العربيات المالية</p>
      </div>
      
      <div className="card shadow-modern mb-8 animate-slideInDown" style={{animationDelay: '0.1s'}}>
        <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
          <span className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center text-white text-sm animate-pulse">
            {editId ? '✏️' : '+'}
          </span>
          {editId ? 'تعديل الحركة' : 'إضافة حركة جديدة'}
        </h3>
        
        <form onSubmit={handleAddMovement} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">اسم العربية</label>
              <select 
                className="input-modern" 
                value={selectedCar} 
                onChange={e => setSelectedCar(e.target.value)} 
                required
              >
                <option value="">اختر اسم العربية</option>
                {cars.map(car => (
                  <option key={car.id} value={car.id}>{car.name}</option>
                ))}
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">الشهر</label>
              <input 
                className="input-modern" 
                type="text" 
                placeholder="الشهر" 
                value={month} 
                onChange={e => setMonth(e.target.value)} 
                required 
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">التاريخ</label>
              <input 
                className="input-modern" 
                type="date" 
                value={date} 
                onChange={e => setDate(e.target.value)} 
                required 
              />
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">المسحوبات (اختياري)</label>
              <input 
                className="input-modern" 
                type="number" 
                placeholder="مبلغ المسحوبات" 
                value={credit} 
                onChange={e => setCredit(e.target.value)} 
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">الشغل (اختياري)</label>
              <input 
                className="input-modern" 
                type="number" 
                placeholder="مبلغ الشغل" 
                value={debit} 
                onChange={e => setDebit(e.target.value)} 
              />
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">تفاصيل الحركة</label>
            <input 
              className="input-modern" 
              type="text" 
              placeholder="تفاصيل الحركة (اختياري)" 
              value={details} 
              onChange={e => setDetails(e.target.value)} 
            />
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">التصنيف</label>
              <select 
                className="input-modern" 
                value={category} 
                onChange={e => setCategory(e.target.value)} 
                required
              >
                <option value="خيام">خيام</option>
                <option value="تكيفيات">تكيفيات</option>
                <option value="اخري وخيام">اخري وخيام</option>
                <option value="اخري">اخري</option>
              </select>
            </div>
            
            <div className="flex gap-2">
              <button className="btn-primary flex-1" type="submit">
                {editId ? 'تحديث الحركة' : 'إضافة حركة'}
              </button>
              {editId && (
                <button 
                  className="btn-secondary" 
                  type="button" 
                  onClick={() => {
                    setEditId(null);
                    setMonth(''); setDate(''); setDebit(''); setCredit(''); setDetails(''); setCategory('اخري');
                  }}
                >
                  إلغاء
                </button>
              )}
            </div>
          </div>
        </form>
        
        {message && <div className="alert-success mt-4">{message}</div>}
      </div>

      <div className="card shadow-modern animate-slideInDown" style={{animationDelay: '0.2s'}}>
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-semibold flex items-center gap-2">
            <span className="w-8 h-8 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-lg flex items-center justify-center text-white text-sm">📊</span>
            كل الحركات ({movements.length})
          </h3>
        </div>
        
        <div className="mb-6">
          <input 
            className="input-modern" 
            type="text" 
            placeholder="🔍 بحث... (رقم، شهر، تاريخ، اسم العربية، تفصيل، تصنيف)" 
            value={search} 
            onChange={e => setSearch(e.target.value)} 
          />
        </div>

        {/* أزرار الترتيب السريع */}
        <div className="mb-4 flex gap-2 flex-wrap">
          <button 
            onClick={() => handleSort('seq')} 
            className={`px-3 py-1 rounded text-sm ${sortBy === 'seq' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'}`}
          >
            ترتيب برقم الحركة {sortBy === 'seq' && (sortOrder === 'asc' ? '↑' : '↓')}
          </button>
          <button 
            onClick={() => handleSort('date')} 
            className={`px-3 py-1 rounded text-sm ${sortBy === 'date' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'}`}
          >
            ترتيب بالتاريخ {sortBy === 'date' && (sortOrder === 'asc' ? '↑' : '↓')}
          </button>
        </div>
        
        <div className="overflow-x-auto">
          <table className="table-modern">
            <thead>
              <tr>
                <th 
                  onClick={() => handleSort('seq')} 
                  style={{cursor: 'pointer', userSelect: 'none'}}
                  title="اضغط للترتيب"
                >
                  رقم الحركة 
                  {sortBy === 'seq' && (
                    <span style={{marginLeft: '5px'}}>
                      {sortOrder === 'asc' ? '↑' : '↓'}
                    </span>
                  )}
                </th>
                <th>الشهر</th>
                <th 
                  onClick={() => handleSort('date')} 
                  style={{cursor: 'pointer', userSelect: 'none'}}
                  title="اضغط للترتيب"
                >
                  التاريخ
                  {sortBy === 'date' && (
                    <span style={{marginLeft: '5px'}}>
                      {sortOrder === 'asc' ? '↑' : '↓'}
                    </span>
                  )}
                </th>
                <th>اسم العربية</th>
                <th>المسحوبات</th>
                <th>الشغل</th>
                <th>تفاصيل</th>
                <th>تصنيف</th>
                <th>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {sortedMovements
                .filter(m => {
                  if (!search) return true;
                  const s = search.toString().toLowerCase();
                  const carName = (cars.find(c => c.id === m.car_id)?.name || '').toString().toLowerCase();
                  return (
                    m.id.toString().includes(s) ||
                    (m.month || '').toString().toLowerCase().includes(s) ||
                    (m.date || '').toString().toLowerCase().includes(s) ||
                    carName.includes(s) ||
                    (m.debit || '').toString().toLowerCase().includes(s) ||
                    (m.credit || '').toString().toLowerCase().includes(s) ||
                    (m.details || '').toString().toLowerCase().includes(s) ||
                    (m.category || '').toString().toLowerCase().includes(s)
                  );
                })
                .map((m, idx) => (
                <tr key={idx}>
                  <td>
                    <span className="inline-flex items-center justify-center w-8 h-8 bg-gradient-to-r from-indigo-500 to-purple-500 text-white text-sm font-bold rounded-lg">
                      {m.id}
                    </span>
                  </td>
                  <td>{m.month}</td>
                  <td>{formatDate(m.date)}</td>
                  <td>
                    <span className="font-medium text-gray-800">
                      {cars.find(c => c.id === m.car_id)?.name || ''}
                    </span>
                  </td>
                  <td>
                    {m.credit && (
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                        {m.credit}
                      </span>
                    )}
                  </td>
                  <td>
                    {m.debit && (
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        {m.debit}
                      </span>
                    )}
                  </td>
                  <td className="max-w-xs truncate">{m.details}</td>
                  <td>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {m.category}
                    </span>
                  </td>
                  <td>
                    <div className="flex gap-2">
                      <button 
                        className="text-indigo-600 hover:text-indigo-800 transition-colors duration-300 font-medium" 
                        onClick={() => handleEdit(m)}
                      >
                        تعديل
                      </button>
                      <button 
                        className="text-red-600 hover:text-red-800 transition-colors duration-300 font-medium" 
                        onClick={() => handleDelete(m.id)}
                      >
                        حذف
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          {movements.filter(m => {
            if (!search) return true;
            const s = search.toString().toLowerCase();
            const carName = (cars.find(c => c.id === m.car_id)?.name || '').toString().toLowerCase();
            return (
              m.id.toString().includes(s) ||
              (m.month || '').toString().toLowerCase().includes(s) ||
              (m.date || '').toString().toLowerCase().includes(s) ||
              carName.includes(s) ||
              (m.debit || '').toString().toLowerCase().includes(s) ||
              (m.credit || '').toString().toLowerCase().includes(s) ||
              (m.details || '').toString().toLowerCase().includes(s) ||
              (m.category || '').toString().toLowerCase().includes(s)
            );
          }).length === 0 && (
            <div className="text-center py-12 text-gray-500">
              <div className="text-6xl mb-4">🔍</div>
              <p className="text-lg">لا توجد نتائج للبحث</p>
              <p className="text-sm">جرب كلمات بحث أخرى</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Movements;
